import { NewsBox, NewsList } from "styles/jss/Home.styles";
import DateStamp from "../../DateStamp";
import { useState } from "react";
import NextImage from "../../NextImage";
import { truncateString } from "../../../utils/helperFunction";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";

export default function NewsListItem({ news }) {
  const { locale } = useRouter();
  const { t } = useTranslation(["homePage"]);

  return (
    <NewsList>
      <div className="header">
        <h3>{t("latest-news")}</h3>
        <Link href={"media-center/news"} locale={locale}>
          <a>
            <span>{t("see-all")}</span>
          </a>
        </Link>
      </div>
      {!!news.slice(3, 9).length &&
        news.slice(3, 9).map(({ id, attributes }) => {
          const { slug, title, thumbnail, datetime } = attributes;
          return (
            <NewsBox key={id}>
              <div className={"content"}>
                <Link href={`media-center/news/${id}/${slug}`}>
                  <a>
                    <p>{truncateString(title, 50)}</p>
                  </a>
                </Link>
                <DateStamp date={datetime} />
              </div>
              <div className="imageWrapper">
                <NextImage
                  layout={"responsive"}
                  width={100}
                  height={100}
                  src={thumbnail.data?.attributes?.formats?.thumbnail?.url}
                  alt={thumbnail.data?.attributes?.caption}
                  placeholder="blur"
                />
              </div>
            </NewsBox>
          );
        })}
    </NewsList>
  );
}
